<template>
  <div>
    <el-submenu v-if="item.children && item.children.length && isShowMenu(item.children)" :index="JSON.stringify(item)">
      <template slot="title">
        <i :class="`iconfont ${item.meta.icon}`"></i>
        <span style="font-size: 0.08333rem;">{{item.name}}</span>
      </template>
      <AsideItem v-for="route in item.children" :key="route.path" :item="route" :hasproductchange="hasproductchange"></AsideItem>
    </el-submenu>
    <template v-else>
      <el-menu-item v-if="item.name==='产品调换记录'"
                    v-show="hasproductchange > 0"
                    :index="item.path">
        <i :class="`iconfont ${item.meta.icon}`"></i><span slot="title">{{item.name}}</span>
      </el-menu-item>
      <el-menu-item v-else
                    :index="item.path">
        <i :class="`iconfont ${item.meta.icon}`"></i><span slot="title">{{item.name}}</span>
      </el-menu-item>
    </template>
  </div>
</template>

<script>
    import AsideItem from './asideItem.vue'
    export default {
        name: "AsideItem",
        components: {
          AsideItem
        },
        props: {
          item: {
            type: Object,
            required: true
          },
          hasproductchange: {
            type: Number
          }
        },
      computed: {
        isShowMenu() {
          return function (array) {
            let flag = false;
            let list = array.filter(item=>{
              return !item.meta.noShowMenu;
            });
            if(list.length){
              flag = true;
            }
            return flag
          }
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layout/asideItem.vue